import React from 'react';
import GenAiReveal from './GenAiReveal';
import { GEN_AI_CREATIVE_LANDING } from '../../data/genAiCreativeLanding';

const GenAiTimeline = () => {
  const { timeline } = GEN_AI_CREATIVE_LANDING;

  return (
    <section className="bg-[#ecebf2] px-5 py-16 md:px-10 md:py-20 xl:px-[100px] xl:py-[120px]">
      <div className="mx-auto max-w-[1240px]">
        <GenAiReveal className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
          <h2 className="max-w-[787px] text-[32px] font-bold leading-none text-[#0b0b0b] md:text-4xl xl:text-[48px]">
            {timeline.title}
          </h2>
          <span className="inline-flex h-12 shrink-0 items-center rounded-2xl bg-[#2b7afe] px-[18px] text-xl font-bold text-white md:text-2xl">
            {timeline.duration}
          </span>
        </GenAiReveal>

        <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5">
          {timeline.steps.map((step, index) => (
            <GenAiReveal key={step.id} delay={index * 70}>
              <article className="relative flex h-full flex-col gap-6 rounded-[20px] bg-white p-7">
                {index < timeline.steps.length - 1 && (
                  <span
                    className="pointer-events-none absolute -right-3 top-[52px] hidden h-0.5 w-6 bg-[#2b7afe]/30 xl:block"
                    aria-hidden
                  />
                )}
                <p className="text-[40px] font-bold leading-none text-[#2b7afe]">
                  {step.number}
                </p>
                <div>
                  <h3 className="text-xl font-bold leading-[1.1] text-[#0b0b0b] md:text-2xl">
                    {step.title}
                  </h3>
                  <p className="mt-2 text-base leading-[1.3] text-[#2f2f2f]/80">
                    {step.description}
                  </p>
                </div>
              </article>
            </GenAiReveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default GenAiTimeline;
